import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SquarePlusMinusIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M19.1715 2.99988H5.17151C4.07151 2.99988 3.17151 3.89988 3.17151 4.99988V18.9999C3.17151 20.0999 4.07151 20.9999 5.17151 20.9999H19.1715C20.2715 20.9999 21.1715 20.0999 21.1715 18.9999V4.99988C21.1715 3.89988 20.2715 2.99988 19.1715 2.99988ZM6.92151 6.99988H10.4215C10.8315 6.99988 11.1715 7.33988 11.1715 7.74988C11.1715 8.15988 10.8315 8.49988 10.4215 8.49988H6.92151C6.51151 8.49988 6.17151 8.15988 6.17151 7.74988C6.17151 7.33988 6.51151 6.99988 6.92151 6.99988ZM18.1715 18.9999H5.17151L19.1715 4.99988V17.9999C19.1715 18.5499 18.7215 18.9999 18.1715 18.9999ZM14.6715 15.9999V17.2499C14.6715 17.6599 15.0115 17.9999 15.4215 17.9999C15.8315 17.9999 16.1715 17.6599 16.1715 17.2499V15.9999H17.4215C17.8315 15.9999 18.1715 15.6599 18.1715 15.2499C18.1715 14.8399 17.8315 14.4999 17.4215 14.4999H16.1715V13.2499C16.1715 12.8399 15.8315 12.4999 15.4215 12.4999C15.0115 12.4999 14.6715 12.8399 14.6715 13.2499V14.4999H13.4215C13.0115 14.4999 12.6715 14.8399 12.6715 15.2499C12.6715 15.6599 13.0115 15.9999 13.4215 15.9999H14.6715Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
